// Constants for the experimental Scaling page (header tabs).

export const ScalingTab = {
  DATA_QA: 'data-qa',
  SCALING_ANALYSIS_RESULTS: 'scaling-analysis-results'
} as const;
export type ScalingTabValue = (typeof ScalingTab)[keyof typeof ScalingTab];

export const SCALING_NAVS: { label: string; key: ScalingTabValue }[] = [
  { label: 'Data QA', key: ScalingTab.DATA_QA },
  { label: 'Scaling Analysis Results', key: ScalingTab.SCALING_ANALYSIS_RESULTS }
];

// The route slug this page is mounted at (used by useTabbedNav to build tab URLs).
export const SCALING_BASE_URL = 'scaling/';
